import { ThankYouType } from '../../shared/enums/thank-you-type.enum';
import { Step } from './step.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ThankYouStep extends Step {
  public text!: string;

  public override thankYouType!: ThankYouType;

  public url!: string;

  public static fromDto(dto: any): ThankYouStep {
    const step: ThankYouStep = new ThankYouStep();
    Step.mapBaseProperties(step, dto);
    step.text = dto.thankYou ? dto.thankYou.thankYouText : '';
    step.thankYouType = dto.thankYou ? dto.thankYou.thankYouType : '';
    step.url = dto.thankYou ? dto.thankYou.thankYouUrl : '';
    return step;
  }
}
